import styled from 'styled-components'

export const CheckboxIconWrapper = styled.div`
  svg {
    height: 20px;
    width: 20px;
  }
`
